<template>
  <div class="d-flex justify-center align-center">
    <v-card class="main-card ma-2" elevation="20" max-width="1500" width="100%">
      <Drawer :step="step" />

      <div class="px-6 pt-6 d-flex justify-center align-start content">
        <v-window v-model="step" class="pt-6" touchless style="width: 100%">
          <v-window-item>
            <Personal :user_prop="user" @next="nextStep" />
          </v-window-item>
          <v-window-item>
            <MedicalQuestions
              :key="keys[1]"
              :user_prop="user"
              @next="nextStep"
              @back="step--"
            />
          </v-window-item>
          <v-window-item>
            <RegisterForm
              :key="keys[2]"
              :user_prop="user"
              @next="nextStep"
              @back="step--"
            />
          </v-window-item>
          <v-window-item style="width: 100%">
            <Result :key="keys[3]" @next="nextStep" @back="step--" />
          </v-window-item>
          <v-window-item>
            <Police
              :key="keys[4]"
              :user_prop="user"
              @next="nextStep"
              @back="step--"
            />
          </v-window-item>
          <!-- <v-window-item>
            <Final :user_prop="user"  @back="step--"  />
          </v-window-item> -->
        </v-window>
      </div>
    </v-card>
  </div>
</template>

<script>
import Drawer from "./components/drawer.vue";
import Personal from "./components/personal.vue";
import MedicalQuestions from "./components/medical_questions.vue";
import RegisterForm from "./components/form.vue";
import ApiService from "../../../services/ApiService";
import Police from "./components/police.vue";
import Final from "./components/final.vue";
import Result from "./components/result.vue";
export default {
  name: "Simulation",
  data() {
    return {
      step: 0,
      user: {},
      api: new ApiService(),
      keys: [false, false, false, false, false, false],
    };
  },

  components: {
    Drawer,
    Personal,
    MedicalQuestions,
    RegisterForm,
    Police,
    Result,
  },

  created() {
    this.getSocio();

    this.user = JSON.parse(localStorage.getItem("user"));
    // console.log('user', this.user);
  },
  methods: {
    getSocio() {
      const socio = JSON.parse(localStorage.getItem("socio"));
      if (socio) {
        this.$store.commit("SET_SOCIO", socio);
        this.$vuetify.theme.primary = socio.cor;

        !this.isColorDark(socio.cor)
          ? this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#013")
          : this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#00C7BA");
      }
      this.$store.commit("SET_COLOR_DARK_OR_LIGHT", "#00C7BA");

      const styleElement = document.createElement("style");
      styleElement.textContent = `:root { 
      --custom-primary-color: ${this.$vuetify.theme.primary || "#00C7BA"};
      --custom-white-color: ${
        this.socio
          ? !this.isColorDark(this.socio.cor)
            ? "#013"
            : "#fff"
          : "#00C7BA"
      };
      --custom-white-second-color: ${
        this.socio
          ? !this.isColorDark(this.socio.cor)
            ? "#013"
            : "#fff"
          : "#fff"
      };
      --custom-second-color: ${this.$vuetify.theme.primary || "#39424e"};
     }`;
      document.head.appendChild(styleElement);
    },
    nextStep(index) {
      this.step++;
      this.keys[index] = !this.keys[index];
      // console.log('nextStep', this.keys);

      this.user = JSON.parse(localStorage.getItem("user"));
    },
    async get_user() {
      await this.api.post(`get-user?cpf=${this.user.cpf}`).then((response) => {
        this.user = response.data;
      }).catch((error) => {
        localStorage.setItem("apiErrorDescription", "Erro ao pegar o usuário!");
      })
    },
    isColorDark(color) {
      if (!color) {
        return false;
      }
      const luminosity = this.calculateLuminosity(color);
      return luminosity < 128;
    },
    isColorLight(color) {
      return !this.isColorDark(color);
    },
    calculateLuminosity(color) {
      const rgb = this.hexToRgb(color);
      const luminosity = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
      return luminosity * 255;
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return {
        r: r / 255,
        g: g / 255,
        b: b / 255,
      };
    },
  },
};
</script>

<style scoped>
.main-card {
  display: flex;
  background: #ffffff;
  border-radius: 25px !important;
}

.content {
  max-width: 70%;
}

@media (max-width: 960px) {
  .main-card {
    flex-direction: column-reverse;
  }
  .content {
    max-width: unset;
  }
}
</style>
